import * as ActionTypes from "../constants/ActionTypes";

// **************************************************************************************************************
export const softwareReducer = (state = {softwareData: {}, softwareOrder: []}, action) => {

    switch (action.type) {

        case ActionTypes.SOFTWARE_SUCCESS:

            const keyValueTypes = {}

            Object.entries(action.response.entities.software).forEach(([key, value]) => {
                keyValueTypes[key] = value
            })

            return Object.assign({}, state, {softwareData: keyValueTypes, softwareOrder: action.response.result});

        default:
            return state
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/Software.js
 **/